<template>
  <div class="coupon">
    <ul class="coupon_ul">
      <li
        v-for="(item, index) in couponArr"
        :key="index"
        class="express_li"
        @click="pre_pay_index = index"
        v-if="item.canshow"
      >
        <!-- <img src="../../assets/images/order/coupon_pre.png" alt /> -->
        <p class="coupon_icon">免费</p>
        <p class="pay_p">
          <span class="pay_p_title">{{ item.title }}</span
          ><br />
          <span
            >{{ distance(item.start_time) }}-{{ distance(item.end_time) }}</span
          ><br />
          <span v-if="item.type == 'drug_reduce'"
            >满{{ item.amount }}减{{ item.reduce_amount }}</span
          >
        </p>
        <div
          :class="[
            { express_icon_active: index == pre_pay_index },
            'express_icon',
          ]"
        ></div>
      </li>
    </ul>
    <div class="submit_content">
      <button class="buynow" @click="choise">确认使用</button>
    </div>
  </div>
</template>

<script>
import http from "../../util/pontusApiConfig";
export default {
  name: "App",
  data() {
    return {
      userid: null,
      token: null,
      couponArr: [
      ],
      pre_pay_index: null,
      allmoney: null,
    };
  },
  created() {
    this.userid = localStorage.getItem("user_id");
    // this.userid = 19
    this.token = localStorage.getItem("token");
    this.allmoney = this.$route.query.money;
    this.getData();
  },
  methods: {
    choise() {
      let arr = this.couponArr[this.pre_pay_index];
      console.log(arr);
      localStorage.setItem("coupon_type", arr.type);
      localStorage.setItem("coupon_id", arr.coupon_id);
      this.$router.go(-1);
    },
    getData() {
      let that = this;
      let params = {
        use_type: "drug",
        provider_id: this.$route.query.provider_id,
        // provider_id: '2',
      };
      let url = "users/" + this.userid + "/coupons/can_use";
      http
        .get(
          url,
          { params },
          {
            headers: {
              Authorization: this.token,
            },
          }
        )
        .then(function (res) {
          // console.log(res.data);
          if (res.data.status_code == 200) {
            that.couponArr = res.data.data;
            let drug_discountArr = [];
            if (res.data.data.drug_discount.length > 0) {
              for (let i = 0; i < res.data.data.drug_discount.length; i++) {
                let arr = res.data.data.drug_discount[i];
                arr["type"] = "drug_discount";
                drug_discountArr.push(arr);
              }
            }
            let drug_reduceArr = [];
            if (res.data.data.drug_reduce.length > 0) {
              for (let i = 0; i < res.data.data.drug_reduce.length; i++) {
                let arr = res.data.data.drug_reduce[i];
                arr["type"] = "drug_reduce";
                if (that.allmoney < arr.amount) {
                  arr["canshow"] = false;
                } else {
                  arr["canshow"] = true;
                }
                drug_reduceArr.push(arr);
              }
            }
            that.couponArr = drug_discountArr.concat(drug_reduceArr);
          }
        });
    },
    distance(day) {
      //过去的时间戳
      var now = new Date(day * 1000); //过去 //年
      var year = now.getFullYear(); //月
      var month = now.getMonth() + 1; //日
      var date = now.getDate(); //时
      var hour = now.getHours(); //分
      var minute = now.getMinutes(); //秒
      var second = now.getSeconds();
      if (month < 10) {
        month = "0" + month;
      }
      if (date < 10) {
        date = "0" + date;
      }
      if (hour < 10) {
        hour = "0" + hour;
      }
      if (minute < 10) {
        minute = "0" + minute;
      }
      if (second < 10) {
        second = "0" + second;
      }
      var timer = year + "-" + month + "-" + date;

      return timer;
    },
  },
};
</script>

<style lang="scss" scoped>
.coupon {
  .coupon_ul {
    width: 100%;
    box-sizing: border-box;
    padding: 10px 15px 0px;
    .express_li {
      width: 100%;
      height: 113px;
      background: url("../../assets/images/order/coupon_bg.png") no-repeat
        center center;
      background-size: 100%;
      // box-shadow: 3px 3px 12px 0px rgba(0, 0, 0, 0.08);
      border-radius: 8px;
      margin-bottom: 10px;
      box-sizing: border-box;
      padding: 16px 47px 22px 20px;
      display: flex;
      .coupon_icon {
        width: 75px;
        height: 75px;
        line-height: 75px;
        background: #ffe2dc;
        color: #fd4343;
        text-align: center;
        border-radius: 4px;
      }
      .pay_p {
        width: calc(100% - 145px);
        font-family: PingFang-SC-Medium, PingFang-SC;
        font-weight: 500;
        line-height: 16px;
        margin-left: 10px;
        border-right: 1px dashed #ffd7cf;
        span {
          width: 100%;
          display: inline-block;
          color: #999;
          font-size: 12px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          line-height: 20px;
        }
        .pay_p_title {
          font-size: 16px;
          font-family: PingFang-SC-Bold;
          font-weight: bold;
          color: #000000;
          margin-bottom: 8px;
        }
      }
      .express_icon {
        width: 18px;
        height: 18px;
        border: 1px solid #CCCCCC;
        border-radius: 50%;
        // background: url("../../assets/images/order/express_nor.png") no-repeat
        //   center center;
        // background-size: cover;
        margin-top: 25px;
        margin-left: 40px;
      }
      .express_icon_active {
        width: 20px;
        height: 20px;
         border: 0px solid #CCCCCC;
        background: url("../../assets/images/order/express_pre.png") no-repeat
          center center;
        background-size: cover;
      }
    }
  }
}
.submit_content {
  width: 100%;
  height: 70px;
  position: fixed;
  bottom: 0;
  left: 0;
  padding: 10px 15px;
  box-sizing: border-box;
  border-top: 1px solid #e4e4e4;
  .submit_money {
    font-size: 14px;
    line-height: 40px;
    font-family: PingFang-SC-Medium, PingFang-SC;
    font-weight: 500;
    display: inline-block;
    span {
      font-weight: bold;
      font-size: 24px;
    }
  }
  .submit_button {
    border: none;
    width: 120px;
    height: 40px;
    background: rgba(172, 75, 56, 1);
    border-radius: 10px;
    text-align: center;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: rgba(255, 255, 255, 1);
    line-height: 25px;
    float: right;
  }
  .buynow {
    width: calc(100% - 40px);
    display: block;
    height: 48px;
    background: rgba(172, 75, 56, 1);
    border-radius: 10px;
    font-size: 18px;
    color: #fff;
    border: none;
    margin: 0 auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/order/coupon.vue